//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingAddressDisclaimerModal",
  components: {
    GenericModal
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    }
  }
});